import React from "react";

export type IconProps = {
  className?: string;
  width?: number;
  height?: number;
  viewBox?: string;
  fill?: string;
  src?: string;
  alt?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

export default function Icon({
  className,
  width = 24,
  height = 24,
  viewBox,
  fill,
  src,
  alt,
  children,
  style,
}: IconProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        width={width}
        height={height}
        loading="lazy"
        style={style}
      />
    );
  }

  return (
    <div className={`dewey--search--icon ${className ?? ""}`}>
      <svg
        width={width}
        height={height}
        viewBox={viewBox ?? `0 0 ${width} ${height}`}
        fill={fill ?? "none"}
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        {children}
      </svg>
    </div>
  );
}
